import React from 'react'
import { InteractionContext } from '@components/interactionContext/context'
import { AppHOC, AppProps } from './AppHOC'

const InsuranceToggleContainer = React.lazy(() => import('@components/InsuranceToggle/InsuranceToggle'))

export const InsuranceToggleApp: React.FC<AppProps> = props => {
  const { widgetContext } = props

  return (
    <AppHOC widgetContext={widgetContext}>
      <InteractionContext.Provider value={{ name: 'insurance-toggle', type: 'action' }}>
        <InsuranceToggleContainer />
      </InteractionContext.Provider>
    </AppHOC>
  )
}
